export const defaultAdminUsersFilterValue = [
  { name: 'id', operator: 'startsWith', type: 'string', value: '' },
  { name: 'firstName', operator: 'startsWith', type: 'string', value: '' },
  { name: 'lastName', operator: 'startsWith', type: 'string', value: '' },
  { name: 'email', operator: 'startsWith', type: 'string', value: '' },
  { name: 'createdAt', operator: 'startsWith', type: 'string', value: '' },
]
